
import { z } from "zod"

export const companyFormSchema = z.object({
  companyName: z.string().min(1, "Company name is required"),
  maxOvertimeHours: z.coerce.number().min(0, "Max overtime hours must be a positive number"),
  weekStartDay: z.string()
})

export type CompanyFormValues = z.infer<typeof companyFormSchema>
